module.exports = __webpack_public_path__ + "img/project_6.994969b3.png";